// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5098":"2ab3f8bc","7976":"6d0845ff"}[chunkId] + ".chunk.css";
};